import React from 'react';
import { PieChart, Pie, Cell } from 'recharts';
import { map, path } from 'ramda';

const getScoreColors = score => {
  if (isNaN(score)) {
    return {
      color: '#7d7d7d',
      backgroundColor: '#bdbdbd'
    };
  }
  if (score < 0.35) {
    return {
      color: '#f34235',
      backgroundColor: '#ee9999'
    };
  } else if (score < 0.6) {
    return {
      color: '#ff9700',
      backgroundColor: '#ffcb7f'
    };
  }
  return {
    color: '#4bae4f',
    backgroundColor: '#a4d5a6'
  };
};

const getChartData = result => {
  const score = path(['evaluation', 'metrics', 'scoreTotal'], result || {});
  if (!score) {
    return {
      colors: getScoreColors(),
      match: 0,
      text: 'N/A'
    };
  }
  const { value } = score;
  return {
    colors: getScoreColors(value),
    match: value,
    text: `${(value * 100).toFixed(0)} %`
  };
};

const ScoreChart = ({ result, size = 48 }) => {
  const { match, colors, text } = getChartData(result);
  const data = [
    { name: 'full', value: match, color: colors.color },
    { name: 'empty', value: 1 - match, color: colors.backgroundColor }
  ];
  return (
    <div style={{ position: 'relative', display: 'inline-block' }}>
      <PieChart width={size} height={size} margin={{ top: 0, left: 0, right: 0, bottom: 0 }}>
        <Pie
          dataKey="value"
          data={data}
          innerRadius="75%"
          outerRadius="100%"
          startAngle={90}
          endAngle={-270}
          isAnimationActive={false}
        >
          {map(d => <Cell key={d.name} fill={d.color} stroke="none" />, data)}
        </Pie>
      </PieChart>
      <div
        style={{
          position: 'absolute',
          color: colors.color,
          verticalAlign: 'middle',
          textAlign: 'center',
          left: 0,
          top: 0,
          bottom: 0,
          right: 0,
          fontSize: 10,
          lineHeight: `${size}px`
        }}
      >
        <span>{text}</span>
      </div>
    </div>
  );
};

export default ScoreChart;


// WEBPACK FOOTER //
// ./src/components/results/ScoreChart.js